angular.module('galilai.creator').factory('layoutService', function($http, api) {
    let cachedLayouts = null
    let expandedLayouts = null
    let hasExpandedAll = false

    function deepMerge(target, source) {
        for (const key in source) {
            if (source[key] instanceof Object && key in target) {
            Object.assign(source[key], deepMerge(target[key], source[key]));
            }
        }

        Object.assign(target || {}, source);
        return target;
    }

    function list(params) {
        if (cachedLayouts && !params) {
            return Promise.resolve(cachedLayouts);
        }
        if (params && params.kind && params.kind != 'smart') {
            return api.searchLayouts(params).then(function(response) {
                let data = response.data;
                if (params.kind) {
                    loadLayoutFonts(data)
                }
                return data;
            })
        }
        let url = window.BASE_URL + '/api/creator/layouts/'
        let promise = null
        if (params && params.kind && params.kind == 'smart') {
            params.seed = safeGetStorage('layouts.seed')
            url = window.BASE_URL + '/api/creator/smart-layouts/'
            if (params.filters) {
                for (let key of Object.keys(params.filters)) {
                    if (params.filters[key] == 'any') {
                        delete params.filters[key]
                    }
                }
            }
            promise = $http.post(url, {params})
        } else {
            promise = $http.get(url)
        }
        return promise.then(function(response) {
            let data = response.data;
            cachedLayouts = data;
            return data;
        });
    }

    function loadFont(name, url) {
        let fontFace = new FontFace(name, `url(${url})`);
        document.fonts.add(fontFace);
        fontFace.load().then(function(loadedFont) {
            //console.log('Font loaded', loadedFont);
        }).catch(function(error) {
            //console.error('Font failed to load', error);
        });
    }
    function loadLayoutFonts(data) {
        let uniqueFonts = new Set()
        function getAllTextElements(tree) {
            for (let element of tree) {
                if (element.type == 'p' || element.type == 'h1') {
                    if (element.computed && element.computed['font-family']) {
                        uniqueFonts.add(element.computed['font-family'])
                    }
                }
                if (element.elements) {
                    getAllTextElements(element.elements)
                }
            }
        }
        for (layoutKey in data.layouts) {
            let layout = data.layouts[layoutKey]
            if (!layout.elements) {
                continue
            }
            getAllTextElements(layout.elements)
        }

        for (let font of uniqueFonts) {
            let fontKey = font.replace(/\"/g, '')
            let url = `https://galilai-bucket.s3.amazonaws.com/creator/fonts/${fontKey}/regular/font.woff`
            loadFont(fontKey, url)
        }
    }

    let cachedOverlays = null
    function overlays() {
        if (cachedOverlays) {
            return Promise.resolve(cachedOverlays);
        }
        return $http.get(window.BASE_URL + '/api/creator/overlays').then(function(response) {
            cachedOverlays = response.data;
            return cachedOverlays;
        });
    }

    function applyModifiers(modifiers, combination) {
        if (!modifiers || modifiers.length == 0) {
            return
        }

        let replacementMap = {}
        for (let modifier of modifiers) {
            let parts = modifier.split(':')
            let key = parts[0]
            let value = parts[1]
            if (!replacementMap[key]) {
                replacementMap[key] = {}
            }
            let valueParts = value.split('_')
            let valueKey = valueParts[0]
            let valueValue = valueParts[1]
            replacementMap[key][valueKey] = valueValue
        }
        function traverseAndReplace(obj) {
            if (Array.isArray(obj)) {
                // If obj is an array, process each element
                obj.forEach((item) => traverseAndReplace(item));
            } else if (obj && typeof obj === 'object') {
                // If obj is an object, iterate over its keys
                for (const key of Object.keys(obj)) {
                    const value = obj[key];

                    // 1) Check if the key exists in replacementMap
                    if (replacementMap[key]) {
                        // If the value is in the replacement map, replace it
                        if (value in replacementMap[key]) {
                            obj[key] = replacementMap[key][value];
                        }
                    }

                    // 2) Special handling for "elements" array: Recursively process elements
                    if (key === 'elements' && Array.isArray(value)) {
                        value.forEach((element) => traverseAndReplace(element));
                    }

                    // 3) Recursively process any nested objects (excluding direct arrays)
                    if (typeof value === 'object' && value !== null) {
                        traverseAndReplace(value);
                    }
                }
            }
        }

        // Apply the transformation
        traverseAndReplace(combination);
    }

    function expand(layout, layoutId, allLayouts) {
        if (!layout || !layout.combinations) {
            return []
        }
        let expandedLayouts = []

        if (layoutId == 'base') {
            return []
        }
        function getElement(layout, key) {
            let element = null
            // Get recursive element by first id then type
            if (layout.id == key) {
                return layout;
            }

            if (!layout.elements) {
                return null;
            }
            element = layout.elements.find(function(e) {
                return e.id == key && e.id
            });
            // Next find by type
            if (!element ) {
                element = layout.elements.find(function(e) {
                    return e.type == key;
                });
            }
            // Now find in sub elements
            if (!element) {
                for (let i = 0; i < layout.elements.length; i++) {
                    let subElement = layout.elements[i];
                    if (subElement.type == 'container') {
                        element = getElement(subElement, key);
                        if (element) {
                            break;
                        }
                    }
                }
            }
            return element;
        }

        function replaceAttributeValue(layout, elementKey, attributes) {
            let element = getElement(layout, elementKey);
            if (!element) {
                return;
            }
            for (let key of Object.keys(attributes)) {
                element[key] = attributes[key];
            }
            return element;
        }

        function applyVariation(layout, variation) {
            let updatedLayout = JSON.parse(JSON.stringify(layout));
            // Flatten variation array (check if element is array and expand)
            let expandedVariation = []
            for (let variationItem of variation) {
                if (Array.isArray(variationItem)) {
                    expandedVariation = expandedVariation.concat(variationItem);
                } else {
                    expandedVariation.push(variationItem);
                }
            }

            // Apply modifiers
            for (let properties of expandedVariation) {
                properties = JSON.parse(JSON.stringify(properties));
                let elementKey = properties.elementKey;
                delete properties.elementKey;
                replaceAttributeValue(updatedLayout, elementKey, properties);
            }
            delete updatedLayout.variations;
            return updatedLayout;
        }

        function combineMixins(mixIds) {
            let kindMerge = Object.keys(mixIds)[0]
            let mixins = mixIds[kindMerge]

            let currentMixin = {}

            for (let mixinID of mixins) {
                let foundMixin = allLayouts.base.combinations.find(function(c) {
                    return c.id == mixinID && (c.enabled || typeof c.enabled == 'undefined');
                });
                if (!foundMixin) {
                    continue
                }
                if (kindMerge == 'merge') {
                    currentMixin = Object.assign({}, currentMixin, foundMixin)
                }
                else if (kindMerge == 'join') {
                    for (let key of Object.keys(foundMixin)) {
                        if (key == 'id' || key == 'enabled') {
                            continue
                        }
                        if (currentMixin[key]) {
                            currentMixin[key] = currentMixin[key].concat(foundMixin[key])
                        } else {
                            currentMixin[key] = foundMixin[key]
                        }
                    }
                }
            }
            currentMixin.id = mixIds[kindMerge].join('+')
            if (Object.keys(currentMixin).filter(function(key) {
                return key != 'id' && key != 'enabled'
            }).length == 0) {
                return null
            }
            return currentMixin
        }

        let globalIndex = 1

        let mappedCombinations = {}
        for (let i = 0; i < layout.combinations.length; i++) {
            let combination = JSON.parse(JSON.stringify(layout.combinations[i]));
            let categories = []
            let tags = new Set()
            if (layout.categories) {
                categories = layout.categories;
            }
            if (layout.tags) {
                layout.tags.forEach(function(tag) {
                    tags.add(tag);
                })
            }

            let combinationItems = []
            let combinationId = null;
            if (typeof combination.enabled != 'undefined' && !combination.enabled) {
                continue;
            }
            if (combination.mix) {
                // Find the combination to mix and merge
                for (let mixId of combination.mix) {
                    let mixCombination = null
                    let modifiers = null
                    if (typeof mixId == 'string') {
                        let parts = mixId.split('+')
                        mixId = parts[0]
                        modifiers = parts.slice(1)
                    }

                    if (mappedCombinations[mixId]) {
                        mixCombination = mappedCombinations[mixId];
                    } else {
                        mixCombination = layout.combinations.find(function(c) {
                            return c.id == mixId;
                        });
                    }
                    if (!mixCombination) {
                        if (allLayouts.base) {
                            // Check if is object
                            if (typeof mixId == 'object') {
                                mixCombination = combineMixins(mixId);
                                if (!mixCombination) {
                                    continue;
                                }
                            } else {
                                mixCombination = allLayouts.base.combinations.find(function(c) {
                                    return c.id == mixId;
                                });
                                if (!mixCombination) {
                                    continue;
                                }
                            }
                        } else {
                            continue;
                        }
                    }
                    if (mixCombination.tags) {
                        mixCombination.tags.forEach(function(tag) {
                            tags.add(tag);
                        })
                    }
                    mixCombination = JSON.parse(JSON.stringify(mixCombination));
                    try {
                        applyModifiers(modifiers, mixCombination)
                    } catch (err) {
                        console.error('Error applying modifiers', err, modifiers, mixCombination)
                    }

                    // Remove id and enabled
                    delete mixCombination.id;
                    delete mixCombination.enabled;
                    if (mixCombination) {
                        combination = deepMerge(mixCombination, combination)
                    }
                }
            }

            if (combination.categories) {
                categories = combination.categories;
            }
            if (combination.tags) {
                combination.tags.forEach(function(tag) {
                    tags.add(tag);
                });
            }

            function getOverlayById(overlayId) {
                if (cachedLayouts.overlays && cachedLayouts.overlays[overlayId]) {
                    return cachedLayouts.overlays[overlayId];
                }
                return null;
            }

            function styleStringToMap(styleString) {
                if (styleString == null) {
                    return {}
                }
                let styleMap = {}
                let styles = styleString.split('_')
                let doubleLetterKeys = [
                    'mt', 'mr', 'mb', 'ml',
                    'pt', 'pr', 'pb', 'pl',
                    'sz',
                    'al', 'am', 'ar',
                ]
                for (let style of styles) {
                    let styleKey = null
                    let styleValue = null
                    if (doubleLetterKeys.indexOf(style.substring(0, 2)) != -1) {
                        styleKey = style.substring(0, 2)
                        styleValue = style.substring(2)
                    } else {
                        styleKey = style.substring(0, 1)
                        styleValue = style.substring(1)
                    }
                    styleMap[styleKey] = styleValue
                }
                return styleMap
            }

            function convertDynamicSlots(areaElementPosition) {
                let style = {}
                if (areaElementPosition == 'tl') {
                    style['position'] = 'absolute'
                    style['top'] = '0'
                    style['left'] = '0'
                } else if (areaElementPosition == 'tr') {
                    style['position'] = 'absolute'
                    style['top'] = '0'
                    style['right'] = '0'
                } else if (areaElementPosition == 'tm') {
                    style['position'] = 'absolute'
                    style['top'] = '0'
                    style['right'] = '0'
                    style['left'] = '0'
                    style['margin-left'] = 'auto'
                    style['margin-right'] = 'auto'
                }
                else if (areaElementPosition == 'bl') {
                    style['position'] = 'absolute'
                    style['bottom'] = '0'
                    style['left'] = '0'
                } else if (areaElementPosition == 'br') {
                    style['position'] = 'absolute'
                    style['bottom'] = '0'
                    style['right'] = '0'
                } else if (areaElementPosition == 'bm') {
                    style['position'] = 'absolute'
                    style['bottom'] = '0'
                    style['right'] = '0'
                    style['left'] = '0'
                    style['margin-left'] = 'auto'
                    style['margin-right'] = 'auto'

                }
                return style
            }

            function convertStyleToCSS(styleMap) {
                let cssStyles = {}
                let mapColors = {
                    'm': 'main',
                    't': 'text',
                    'h': 'highlight',
                }

                function applyPixelsOrPercentValue(value) {
                    if (value.indexOf('%') == -1) {
                        return value + 'px'
                    }
                    return value
                }

                for (let key of Object.keys(styleMap)) {
                    let value = styleMap[key]
                    if (key == 'm') {
                        cssStyles['margin'] = value + 'px'
                    } else if (key == 'mt') {
                        cssStyles['margin-top'] = value + 'px'
                    } else if (key == 'mr') {
                        cssStyles['margin-right'] = value + 'px'
                    } else if (key == 'mb') {
                        cssStyles['margin-bottom'] = value + 'px'
                    } else if (key == 'ml') {
                        cssStyles['margin-left'] = value + 'px'
                    } else if (key == 'p') {
                        cssStyles['padding'] = value + 'px'
                    } else if (key == 'pt') {
                        cssStyles['padding-top'] = value + 'px'
                    } else if (key == 'pr') {
                        cssStyles['padding-right'] = value + 'px'
                    } else if (key == 'pb') {
                        cssStyles['padding-bottom'] = value + 'px'
                    } else if (key == 'pl') {
                        cssStyles['padding-left'] = value + 'px'
                    } else if (key == 'w') {
                        cssStyles['width'] = applyPixelsOrPercentValue(value)
                    } else if (key == 'h') {
                        cssStyles['height'] = applyPixelsOrPercentValue(value)
                    } else if (key == 'c') {
                        cssStyles['color'] = mapColors[value] || value
                    } else if (key == 'f') {
                        cssStyles['fill'] = mapColors[value] || value
                    } else if (key == 'o') {
                        cssStyles['opacity'] = value/10
                    } else if (key == 'sz') {
                        cssStyles['width'] = applyPixelsOrPercentValue(value)
                        cssStyles['height'] = applyPixelsOrPercentValue(value)
                    } else if (key == 'al') {
                        cssStyles['align-self'] = 'start'
                    } else if (key == 'am') {
                        cssStyles['align-self'] = 'center'
                    } else if (key == 'ar') {
                        cssStyles['align-self'] = 'end'
                    }
                }
                return cssStyles
            }
            function dynamicAreaCombination(combKey, combination) {
                let combinedElements = []
                let areaStyle = null
                let areaId = null
                let parts = combKey.split(':')
                areaId = parts[1]
                if (parts.length > 2) {
                    areaStyle = parts[2]
                }

                let globalStyle = styleStringToMap(areaStyle)

                let areaElements = []
                if (!Array.isArray(combination[combKey])) {
                    areaElements = [combination[combKey]]
                } else {
                    areaElements = combination[combKey]
                }

                function getBaseStyle(element) {
                    let baseStyle = JSON.parse(JSON.stringify(element))
                    delete baseStyle.uniqueId
                    delete baseStyle.type
                    delete baseStyle.value
                    return baseStyle
                }

                for (let areaElement of areaElements) {
                    if (typeof areaElement == 'string') {
                        let overlay = getOverlayById(areaElement)
                        if (overlay && overlay.elements) {
                            for (let overlayElement of overlay.elements) {
                                let baseStyle = getBaseStyle(overlayElement)

                                let element = JSON.parse(JSON.stringify(overlayElement))
                                let convertedStyles = convertStyleToCSS(globalStyle)
                                convertedStyles = Object.assign({}, baseStyle, convertedStyles)
                                for (let key of Object.keys(convertedStyles)) {
                                    element[key] = convertedStyles[key]
                                }
                                combinedElements.push(element)
                            }
                        }
                    } else {
                        let areaElementKey = Object.keys(areaElement)[0]
                        let areaElementParts = areaElementKey.split(':')
                        let areaElementPosition = areaElementParts[0]
                        let areaElementStyle = null
                        if (areaElementParts.length > 1) {
                            areaElementStyle = areaElementParts[1]
                        }
                        let localStyle = styleStringToMap(areaElementStyle)

                        let style = Object.assign({}, globalStyle, localStyle)

                        // Dynamic Slots
                        let slotsStyles = convertDynamicSlots(areaElementPosition)

                        let areaElementValue = areaElement[areaElementKey]
                        let overlay = getOverlayById(areaElementValue)
                        if (overlay && overlay.elements) {
                            for (let overlayElement of overlay.elements) {
                                let baseStyle = getBaseStyle(overlayElement)
                                let element = JSON.parse(JSON.stringify(overlayElement))
                                let convertedStyles = convertStyleToCSS(style)
                                convertedStyles = Object.assign({}, baseStyle, slotsStyles, convertedStyles)
                                for (let key of Object.keys(convertedStyles)) {
                                    element[key] = convertedStyles[key]
                                }
                                combinedElements.push(element)
                            }
                        }
                    }
                }
                let combValue = {
                    elements: combinedElements,
                }
                let combItem = Object.assign({}, combValue, {elementKey: areaId});
                return combItem
            }
            let meta = null
            let constraints = null
            let hasArea = false
            for (let combKey in combination) {
                if (combKey.indexOf('area:') != -1) {
                    let combItem = dynamicAreaCombination(combKey, combination);
                    combinationItems.push(combItem);
                    continue;
                }
                if (combKey == 'mix') {
                    continue
                }
                if (combKey == 'constraints') {
                    constraints = combination[combKey];
                    continue
                }
                if (combKey == 'meta') {
                    meta = combination[combKey];
                    continue
                }
                if (combKey == 'id') {
                    combinationId = layoutId + '.' + combination[combKey];
                    continue;
                }
                let combValue = combination[combKey];
                let combItem = Object.assign({}, combValue, {elementKey: combKey});
                combinationItems.push(combItem);
            }
            mappedCombinations[combination.id] = combination;
            if (categories) {
                mappedCombinations[combination.id].categories = categories;
            }
            if (tags.size > 0) {
                mappedCombinations[combination.id].tags = Array.from(tags);
            }
            if (constraints) {
                mappedCombinations[combination.id].constraints = constraints;
            }
            if (meta) {
                mappedCombinations[combination.id].meta = meta;
            }

            let expandedLayout = JSON.parse(JSON.stringify(layout));
            let newLayout = applyVariation(expandedLayout, combinationItems);
            newLayout.label = combinationId || 'Layout' + '-' + globalIndex;
            newLayout.categories = categories;
            newLayout.tags = Array.from(tags);
            newLayout.brandKit = layout.brandKit || null;
            newLayout.classification = layout.classification || null;
            newLayout.invert = combination.invert || false;

            if (meta) {
                newLayout.meta = meta;
            }
            if (constraints) {
                newLayout.constraints = constraints;
            }
            expandedLayouts.push(newLayout);
            globalIndex++
        }
        return expandedLayouts;
    }

    const scopedEval = function(scope, script) {
        script = script.replace(/\$/g, 'this.')
        return Function(`"use strict"; return ${script}`).bind(scope)();
    }

    function filterLayout(layout, item) {
        // TODO - review
        if (!item) {
            return true
        }
        item = JSON.parse(JSON.stringify(item))
        if (!layout.constraints) {
            return true
        }

        for (key of Object.keys(item)) {
            if (typeof item[key] == 'string') {
                item[key] = item[key].replace(/<[^>]*>/g, '');
            }
        }
        for (let constraint of layout.constraints) {
            try {
                if (!scopedEval(item, constraint)) {
                    return false
                }
            } catch(e) {
                // console.log('Error in constraint', item)
                // console.log('Error in constraint', e)
                return false
            }
        }
        return true
    }

    function expandAll() {
        return list().then(function(layouts) {
            let layoutsConfig = JSON.parse(JSON.stringify(layouts))
            expandedLayouts = {}
            // TASK [HP] Performance this is slow
            // TASK [HP] This is duplicated
            for (let layoutKey in layoutsConfig.layouts) {
                for (layout of expand(layoutsConfig.layouts[layoutKey], layoutKey, layoutsConfig.layouts)) {
                    expandedLayouts[layout.label] = layout
                }
            }
            hasExpandedAll = true
        })
    }

    function waitForLayouts() {
        return new Promise(function(resolve, reject) {
            if (hasExpandedAll && expandedLayouts && Object.keys(expandedLayouts).length > 0) {
                return resolve(expandedLayouts)
            }
            return expandAll().then(function() {
                resolve(expandedLayouts)
            })
        })
    }

    function addDynamicLayout(layout) {
        if (!expandedLayouts) {
            expandedLayouts = {}
        }
        return list().then(function(layoutsConfig) {
            try {
                let dynamicLayoutKey = null
                if (!layout?.id) {
                    console.error('Layout id is null', layout)
                }
                if (layout?.id?.startsWith('s-')) {
                    dynamicLayoutKey = layout.id.split('.')[0]
                }
                else if (layout?.id) {
                    dynamicLayoutKey = layout.id.split('.').slice(0, -1).join('.')
                }
                if (!expandedLayouts[dynamicLayoutKey]) {
                    for (layout of expand(layout.data, dynamicLayoutKey, layoutsConfig.layouts)) {
                        expandedLayouts[layout.label] = layout
                    }
                }
            } catch (err) {
                console.error('Error adding dynamic layout', err)
            }
        })
    }

    function getExpandedLayout(label) {
        if (!expandedLayouts) {
            throw new Error('Layouts not loaded yet')
        }
        return expandedLayouts[label]
    }

    return {
        addDynamicLayout: addDynamicLayout,
        waitForLayouts: waitForLayouts,
        getExpandedLayout: getExpandedLayout,
        filter: filterLayout,
        expand: expand,
        list: list,
        overlays: overlays,
    }
});
